import { Box, useBreakpointValue } from "@chakra-ui/react";
import dynamic from "next/dynamic";
import { getImageProps } from "next/image";
import { useEffect, useState } from "react";
import { useExperience } from "@/store/useExperience";
import Menu from "@/components/menu";

const Experience = dynamic(() => import("@/components/experience"), {
  ssr: false,
});

const DESKTOP_QUERY = "(min-width: 62em)";

function PosterPicture({ opacity }: { opacity: number }) {
  const common = { fill: true, priority: true, sizes: "100vw", alt: "" };
  const {
    props: { srcSet: mobile },
  } = getImageProps({ ...common, src: "/img/home-poster-mob.webp" });
  const {
    props: { srcSet: desktop, ...rest },
  } = getImageProps({ ...common, src: "/img/home-poster.webp" });

  return (
    <picture>
      <source media={DESKTOP_QUERY} srcSet={desktop} />
      <source srcSet={mobile} />
      <img
        {...rest}
        alt=""
        style={{
          position: "fixed",
          left: 0,
          top: 0,
          height: "100vh",
          width: "100vw",
          objectFit: "cover",
          opacity,
          transition: "1s opacity",
          zIndex: 0,
        }}
      />
    </picture>
  );
}

export default function Home() {
  const status = useExperience((state) => state.status);
  const wantsPlay = useExperience((state) => state.wantsPlay);
  const sceneReady = useExperience((state) => state.sceneReady);
  const resetScene = useExperience((state) => state.resetScene);
  const isDesktop = useBreakpointValue({ base: false, lg: true });

  const [mountExperience, setMountExperience] = useState(false);

  useEffect(() => {
    if (!window.matchMedia(DESKTOP_QUERY).matches) return;
    // eslint-disable-next-line react-hooks/set-state-in-effect -- matchMedia no existe en el server: si esto se derivara en el render habría mismatch de hidratación.
    setMountExperience(true);
  }, []);

  useEffect(() => {
    // eslint-disable-next-line react-hooks/set-state-in-effect -- latch: una vez montada la escena no se desmonta por volver wantsPlay a false.
    if (wantsPlay) setMountExperience(true);
  }, [wantsPlay]);

  // On mobile, tear the 3D scene down when returning to the menu so it
  // shows the poster again instead of the idle camera orbiting the car.
  useEffect(() => {
    if (window.matchMedia(DESKTOP_QUERY).matches) return;
    if (status !== "idle" || !sceneReady) return;
    // eslint-disable-next-line react-hooks/set-state-in-effect -- teardown en mobile al volver al menú; depende de matchMedia, que es client-only.
    setMountExperience(false);
    resetScene();
  }, [status, sceneReady, resetScene]);

  return (
    <Box h="100vh">
      <PosterPicture opacity={sceneReady ? 0 : 1} />

      {mountExperience && <Experience isDesktop={!!isDesktop} />}

      <Menu
        opacity={status === "idle" ? 1 : 0}
        pointerEvents={status === "idle" ? "auto" : "none"}
      />
    </Box>
  );
}
